export enum SavedReportDragItemType {
  savedReportTile = 'SAVED_REPORT_TILE'
}
